import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useMessage } from 'naive-ui'
import TeamLink from '@/components/invite/teamLink.vue'
import { useAppDialog } from '@/components/appDialog'
import useTeamMember from '@teams/common/hooks/useTeamMember'
import handleResponseError from '@teams/common/hooks/useResponseError'


export default /*#__PURE__*/_defineComponent({
  __name: 'teamShareDialog',
  setup(__props) {

const { memberManager, memberListManger } = useTeamMember()
const appDialog = useAppDialog()
const message = useMessage()
async function onAddMember() {
  const memberids = await memberListManger.getAllMemberId()
  const disableUserList = memberids.map(id => ({ userid: id }))
  appDialog.show({
    name: 'MemberSelector',
    componentEvents: {
      selected: onSelected
    },
    componentProps: {
      disableUserList
    }
  })
}

async function onSelected(items) {
  try {
    await memberManager.add(items.map(item => item.userid))
    message.success('添加成功', { duration: 2000 })
  } catch (e) {
    handleResponseError(e)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TeamLink, { onAddMember: onAddMember }))
}
}

})